import {
  Id,
  Options,
  Resource,
  ServerResponse,
  SuccessResponse
} from 'services/api';

import Base from '../Base';

/**
 * This class handles api requests related to company and its entities/resources.
 */
export default class Company extends Base {
  constructor(options: Options) {
    super(options);
  }

  protected getEntities<R extends ServerResponse, P = Record<string, any>>(
    entities: Resource,
    params?: P,
    company_id?: Id
  ) {
    const url = this.buildUrl(entities, company_id);
    return this.makeRequest<R>({
      url,
      method: this._request.Get,
      params
    });
  }

  protected getEntity<R extends ServerResponse>(
    entities: Resource,
    id: Id | string,
    company_id?: Id
  ) {
    const url = this.buildUrl(entities, company_id, id);
    return this.makeRequest<R>({
      url,
      method: this._request.Get
    });
  }

  protected createEntity<R extends ServerResponse, Payload>(
    entity: Resource,
    payload: Payload,
    company_id?: Id
  ) {
    const url = this.buildUrl(entity, company_id);
    return this.makeRequest<R, Payload>({
      url,
      method: this._request.Post,
      data: payload
    });
  }

  protected updateEntity<Payload>(
    entities: Resource,
    id: Id,
    payload: Payload,
    company_id?: Id
  ) {
    const url = this.buildUrl(entities, company_id, id);
    return this.makeRequest<SuccessResponse, Payload>({
      url,
      method: this._request.Put,
      data: payload
    });
  }

  protected deleteEntity(entities: Resource, id: Id, company_id?: Id) {
    const url = this.buildUrl(entities, company_id, id);
    return this.makeRequest<SuccessResponse>({
      url,
      method: this._request.Delete
    });
  }

  protected deleteEntities<Payload>(
    entities: Resource,
    payload: Payload,
    company_id?: Id
  ) {
    const url = this.buildUrl(entities, company_id);
    return this.makeRequest<SuccessResponse, Payload>({
      url,
      method: this._request.Delete,
      data: payload
    });
  }

  /**
   * Build URL for api request. The availability of `company_id` determines which variation of URL path to use.
   * - /company/:resource/:id?
   * - /companies/:company_id/:resource/:id?
   * @param resource what company resource, e.g location, department, and etc...
   * @param company_id company id
   * @param id  resource id
   */
  buildUrl(resource: Resource, company_id?: Id, id?: Id | string) {
    const path = `${
      company_id ? `companies/${company_id}` : 'company-portal'
    }/${id ? `${resource}?id=${id}` : resource}`;

    // todo: this is require to be fix for ops portal integration
    // const prefix = `${
    //   company_id ? `companies/${company_id}` : 'company-portal'
    // }`;
    // const entity = id !== undefined ? `${ company_id ? `${resource}/${id}` : `${resource}?id=${id}`}` : resource;
    // const path = `${prefix}/${entity}`;

    return this.generateUrl(path);
  }
}
